module.exports = __webpack_public_path__ + "static/media/rower.846b9cfa.png";